module.exports = __webpack_public_path__ + "static/img/slide-prev.8efb9984.svg";